import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FeatureToggleModule } from 'ngx-feature-toggle';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import { MatDialogModule } from '@angular/material/dialog';
import { AvatarDialogModule } from '../shared/avatar-dialog/avatar-dialog.module';
import { MatIconModule } from '@angular/material/icon';

const material = [MatCardModule, MatButtonModule, MatDialogModule, MatIconModule];

@NgModule({
    declarations: [DashboardComponent],
    imports: [
        CommonModule,
        DashboardRoutingModule,
        RouterModule,
        FeatureToggleModule,
        AvatarDialogModule,
        TranslateModule.forChild(),
        ...material,
    ],
    providers: [],
    exports: [],
})
export class DashboardModule {}
